import { render, staticRenderFns } from "./irr.vue?vue&type=template&id=01d8ffca&scoped=true"
import script from "./irr.vue?vue&type=script&lang=js"
export * from "./irr.vue?vue&type=script&lang=js"
import style0 from "./irr.vue?vue&type=style&index=0&id=01d8ffca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d8ffca",
  null
  
)

export default component.exports